export default __webpack_public_path__ + "static/media/cloudkit.891168e1.svg";